export const MAX_DAYS = 183;
export const MAX_EVENTS = 200;
export const WEEKDAYS = [[1, "Mon"], [2, "Tue"], [3, "Wed"], [4, "Thu"], [5, "Fri"], [6, "Sat"], [0, "Sun"]];
export const MON_FRI = [1, 2, 3, 4, 5];

const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const parse = (s) => {
  const [y, m, d] = String(s).split("-").map(Number);
  return new Date(y, m - 1, d);
};
export const addDays = (s, n) => {
  const d = parse(s);
  d.setDate(d.getDate() + n);
  return ymd(d);
};

/** Every date from start to until (inclusive, local) that falls on one of the chosen weekdays (0 = Sunday). */
export const weeklyDates = (start, until, days) => {
  if (!start || !until || !days.length || until < start) return [];
  const out = [];
  for (let d = parse(start); ymd(d) <= until && out.length <= MAX_EVENTS; d.setDate(d.getDate() + 1)) {
    if (days.includes(d.getDay())) out.push(ymd(d));
  }
  return out;
};
